"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _style = _interopRequireDefault(require("webmotors-react-pj/frame/header/logged/items/user/popover/style"));
var _info = _interopRequireDefault(require("webmotors-react-pj/frame/header/logged/items/user/info"));
var _menu = _interopRequireDefault(require("webmotors-react-pj/frame/header/logged/items/user/menu"));
var _default = () => _react.default.createElement(_style.default, null, _react.default.createElement(_info.default, null), _react.default.createElement(_menu.default, null));
exports.default = _default;